'use strict'

import Vue from 'vue'

const state = {
  menuList: [],
  navigation: {},
  navigationMiddleList: [],
  navigationSmallList: []
}

const getters = {
  getMenuList (state) {
    return state.menuList
  },
  getNavigation (state) {
    return state.navigation
  },  
  getNavigationMiddleList (state) {
    return state.navigationMiddleList
  },  
  getNavigationSmallList (state) {
    return state.navigationSmallList
  },  
}

const mutations = {
  setMenuList (state, { menuList }) {
    state.menuList = menuList
  },
  setNavigation (state, { navigation }) {
    state.navigation = navigation
  },
  setNavigationMiddleList (state, { navigationMiddleList }) {
    state.navigationMiddleList = navigationMiddleList
  },
  setNavigationSmallList (state, { navigationSmallList }) {
    state.navigationSmallList = navigationSmallList
  }
}

const actions = {
  load ({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .get('/menu/list')
        .then(response => {
          if (response.data.result) {
            commit('setMenuList', {
              menuList: response.data.result
            })
          }
          resolve()
        })
        .catch(e => reject(e))
    })    
  },
  navigation ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      if ( params.menuId == 'home' ) {
        commit('setNavigation', {
          navigation: { bigMenuNo : 0, bigMenuName : 'home' }
        })        

        commit('setNavigationMiddleList', { navigationMiddleList: [] })
        commit('setNavigationSmallList', { navigationSmallList: [] })

        resolve();
        return;
      }

      Vue.httpClient
        .get('/menu/navigation', {params : {menuId : params.menuId}})
        .then(response => {
          if (response.data.result) {
            commit('setNavigation', {
              navigation: response.data.result
            })
          }
          
          // 중분류 목록
          if ( response.data.result.bigMenuNo > 0 ) {
            Vue.httpClient
              .get('/menu/list/parent', {params : {parentMenuNo : response.data.result.bigMenuNo}})
              .then(function(response) {
                if (response.data.result) {
                  commit('setNavigationMiddleList', { navigationMiddleList: response.data.result })
                } else {
                  commit('setNavigationMiddleList', { navigationMiddleList: [] })
                }
              })
          } else {
            commit('setNavigationSmallList', { navigationMiddleList: [] })
          }

          // 소분류 목록
          if ( response.data.result.middleMenuNo > 0 ) {
            Vue.httpClient
            .get('/menu/list/parent', {params : {parentMenuNo : response.data.result.middleMenuNo}})
            .then(function(response) {
              if (response.data.result) {
                commit('setNavigationSmallList', { navigationSmallList: response.data.result })
              } else {
                commit('setNavigationSmallList', { navigationSmallList: [] })
              }
            })
          } else {
            commit('setNavigationSmallList', { navigationSmallList: [] })
          }

          resolve()  
        })
        .catch(e => reject(e))
    })
  },
  selectNavigationMenu ({ commit, state }, params) { 
    return new Promise((resolve, reject) => {
      if (params.depth == 1) {
        state.navigation.bigMenuNo   = params.navigation.menuNo;
        state.navigation.bigMenuName = params.navigation.menuName;
      } else if (params.depth == 2) {
        state.navigation.middleMenuNo   = params.navigation.menuNo;
        state.navigation.middleMenuName = params.navigation.menuName;        
      }

      Vue.httpClient
        .get('/menu/list/parent', {params : {parentMenuNo : params.navigation.menuNo}})
        .then((response) => {
          var isRoute = false;

          if ( response.data.result ) {
            if (params.depth == 1) {
              state.navigation.middleMenuNo   = response.data.result[0].menuNo;
              state.navigation.middleMenuName = response.data.result[0].menuName;

              commit('setNavigationMiddleList', { navigationMiddleList: response.data.result })
            } else if (params.depth == 2) {
              state.navigation.smallMenuNo   = response.data.result[0].menuNo;
              state.navigation.smallMenuName = response.data.result[0].menuName;

              commit('setNavigationSmallList', { navigationSmallList: response.data.result })
            }
          } else {
            isRoute = true;
          }

          resolve(isRoute)  
        })  
        .catch(e => reject(e)) 
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/stores/modules/TopMenu.js